// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8506":"725a2798","9179":"d1248c4c"}[chunkId] + ".chunk.css";
};